import React, { memo } from 'react';
import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

import { ShippingAddressField } from '../../../../store/shipping/shipping.types';

import { TStandardTextFieldProps } from './Fields';

const RecipientApartment = ({ control, error, disabled, ...fieldProps }: TStandardTextFieldProps): JSX.Element => (
  <Controller
    control={control}
    name={ShippingAddressField.Address2}
    render={({ value, onChange }) => (
      <TextField
        name={ShippingAddressField.Address2}
        fullWidth
        variant="outlined"
        error={!!error}
        helperText={error}
        disabled={disabled}
        value={value}
        onChange={onChange}
        data-testid="ShippingAddressForm.RecipientApartment"
        data-private="lipsum"
        {...fieldProps}
      />
    )}
  />
);

export default memo<TStandardTextFieldProps>(RecipientApartment);
